module.exports = __webpack_public_path__ + "static/no-estimates-212e23df24af6378cc8f6046be912add.png";